/** PNG export via html-to-image (dynamic-imported). */

export interface PngExportOptions {
  filename?: string;
  pixelRatio?: number;
  /** Pre-clone callback to remove edit-only chrome from the snapshot. */
  filter?: (node: Element) => boolean;
}

export async function exportElementToPng(
  element: HTMLElement,
  options: PngExportOptions = {},
): Promise<void> {
  // Wait for any pending font loads to avoid blank-text snapshots
  await document.fonts.ready;

  const { toPng } = await import('html-to-image');
  const dataUrl = await toPng(element, {
    pixelRatio: options.pixelRatio ?? 2,
    backgroundColor: '#ece5d2',
    cacheBust: true,
    filter: options.filter
      ? (node) => options.filter!(node as Element)
      : (node) => {
          if (!(node instanceof Element)) return true;
          // Skip the editor toolbar, history panel, AI drawer, undo toast,
          // and React Flow's interactive controls.
          if (node.matches('[data-testid="editor-root"] > div:first-child')) return false;
          if (node.matches('[data-testid="history-panel"]')) return false;
          if (node.matches('[data-testid="ai-drawer"]')) return false;
          if (node.matches('[data-testid="undo-toast"]')) return false;
          if (node.matches('[data-testid="template-picker"]')) return false;
          if (node.classList.contains('react-flow__controls')) return false;
          if (node.classList.contains('react-flow__attribution')) return false;
          return true;
        },
  });
  triggerDownload(dataUrl, options.filename ?? 'fiche.png');
}

function triggerDownload(dataUrl: string, filename: string): void {
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
